// extracted by mini-css-extract-plugin
export default {"innerWrapper":"_z-z","tooltipWrapper":"aA-z","icon":"bA-z","tooltip":"cA-z","content":"dA-z"};